<template>
  <div>
    <div
      class="node-item"
      v-on:dblclick="popup"
      @click="showTooltip($event, data.node, data.note)"
    >
      <div class="node-item-icon">
        <v-icon :style="colorStyle">{{ data.ui ? data.ui.icon : '' }}</v-icon>
        <div v-if="data.node === 'stamp_service'" class="node-item-icon-status">
          <v-icon
            v-if="data.property.status === 'success'"
            class="icon icon-success"
          >
            fa-check-circle
          </v-icon>
          <v-icon
            v-if="data.property.status === 'fail'"
            class="icon icon-danger"
          >
            fa-times-circle
          </v-icon>
        </div>
      </div>
      <div
        :style="colorStyle"
        class="node-text"
        v-html="substring(data.name, 22)"
      ></div>
    </div>

    <v-tooltip
      top
      v-model="tooltip.active"
      :position-x="tooltip.positionX"
      :position-y="tooltip.positionY"
      :max-width="400"
    >
      <span class="overflow-wrap" v-html="replaceString(tooltip.text)"> </span>
    </v-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'
import bus from '../utils/event-bus'

export default {
  data() {
    return {
      dataId: null,
      data: '',
      tooltip: {
        active: false,
        text: '',
        positionX: 0,
        positionY: 0
      },
      tooltipTimeout: null
    }
  },
  computed: {
    // backgroundStyle() {
    //   return { backgroundColor: this.data.bg || '#FFFFFF' }
    // },
    colorStyle() {
      let color = _.find(this.$nodeColor, { bg: this.data.bg || '#FFFFFF' })
      return { color: `${color ? color.text : '#222222'} !important` }
      // return this.data.node === 'note'
      //   ? {
      //       color: `#222222 !important`
      //     }
      //   : {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      const id = this.$el.parentElement.parentElement.id
      this.dataId = id

      bus.$emit('nodeData', id)
    })

    bus.$on('SendNodeData', data => {
      if (data.id === this.dataId) {
        this.data = data.data

        const divId = document.getElementById(this.dataId)
        if (divId) divId.style.backgroundColor = this.data.bg || '#FFFFFF'
      }
    })
  },
  methods: {
    popup() {
      // const nopop = [
      //   'enter',
      //   'exit',
      //   'clear_retry',
      //   'disconnect'
      // ]
      // if (nopop.includes(this.data.node)) return

      bus.$emit('openDrawflowDetail', null)
    },
    substring(str, length) {
      if (!str) return
      if (this.data.node === 'note') return str.replace(/\n/g, '<br>')

      return str.length > length ? `${str.substring(0, length)}...` : str
    },
    replaceString(str) {
      if (!str) return

      const blackListRegex = /(<[^>]+>|<[^>]>|<\/[^>]+>)/gi
      str = str.replace(blackListRegex, '')

      // str = str.length > 100 ? `${str.substring(0, 100)}...` : str
      return str.replace(/\n/g, '<br>')
    },
    showTooltip(event, node, text) {
      if (node === 'note') return

      if (!text) return

      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
      }

      if (this.tooltip.active) {
        this.tooltip.active = false
      }

      const box = event.target.parentElement
      const bounds = box.getBoundingClientRect()

      this.tooltip = {
        active: true,
        text: text,
        positionX: bounds.x + bounds.width / 2,
        positionY: bounds.y
      }

      this.tooltipTimeout = setTimeout(() => {
        this.tooltip.active = false
      }, 2000)
    }
  }
}
</script>
